import React, { Component } from "react";
import T from "prop-types";
import classNames from "classnames";
import {
  POUNDS,
  KILOS,
  NET_WEIGHT,
  NET_WEIGHT_UNIT,
  NET_WEIGHT_OZ
} from "MODULES/parts/constants";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import { calculateNetValue } from "LIB/formatters/weight";
import { isEmpty } from "lodash";

export class NetWeight extends Component {
  static propTypes = {
    net_weight: T.shape({
      input: F.stringInput.isRequired,
      meta: F.meta.isRequired
    }).isRequired,
    net_weight_unit: T.shape({
      input: F.stringInput.isRequired
    }).isRequired,
    net_weight_oz: T.shape({
      input: F.stringInput.isRequired
    }).isRequired,
    required: T.bool,
    label: T.string
  };

  state = {
    open: false
  };

  setPounds = () => {
    if (this.props.net_weight_unit.input.value !== POUNDS) {
      const lbs = calculateNetValue(
        KILOS,
        Number(this.props.net_weight.input.value)
      );
      if (Number(lbs) > 0) {
        let remainder = lbs % 1;
        remainder = (remainder * 16).toFixed(2);
        this.props.net_weight_oz.input.onChange(remainder);
      }

      this.props.net_weight.input.onChange(Math.floor(lbs));
    }
    this.props.net_weight_unit.input.onChange(POUNDS);
    this.close();
  };

  setKilos = () => {
    if (this.props.net_weight_unit.input.value !== KILOS) {
      this.props.net_weight.input.onChange(
        calculateNetValue(
          POUNDS,
          Number(this.props.net_weight.input.value),
          Number(this.props.net_weight_oz.input.value)
        )
      );
    }
    this.props.net_weight_unit.input.onChange(KILOS);
    this.props.net_weight_oz.input.onChange(null);
    this.close();
  };

  updateWeight = e => {
    const val = isEmpty(e.target.value) ? null : Number(e.target.value);
    this.props.net_weight.input.onChange(val);
    this.close();
  };

  updateOz = e => {
    const val = isEmpty(e.target.value) ? null : e.target.value;
    this.props.net_weight_oz.input.onChange(val);
    this.close();
  };

  toggle = () => this.setState({ open: !this.state.open });
  close = () => this.setState({ open: false });

  render() {
    const {
      label = "Weight",
      required,
      net_weight: netWeight,
      net_weight_unit: unit,
      net_weight_oz: netWeightOz
    } = this.props;
    const { open } = this.state;
    const { meta: { touched, invalid, error } } = netWeight;
    const hasError = touched && invalid;

    const formGroupClasses = classNames("form-group", {
      "has-error": hasError
    });

    const inputGroupClasses = classNames("input-group-btn dropdown", { open });

    const errors =
      hasError &&
      error.map(m => (
        <span className="help-block" key={m}>
          {m}
        </span>
      ));

    return (
      <div className={formGroupClasses}>
        <label htmlFor={netWeight.input.name} className="control-label">
          {label}
          {required && <sup className="small text-danger">*</sup>}
        </label>
        <div className="input-group">
          <input
            type="number"
            min={unit.input.value === KILOS ? "0.001" : "0"}
            step={unit.input.value === KILOS ? "0.001" : "1"}
            className="form-control"
            {...netWeight.input}
            onChange={this.updateWeight}
            onBlur={this.updateWeight}
          />
          <span className="input-group-addon">{unit.input.value}</span>
          {unit.input.value === POUNDS && [
            <input
              type="number"
              className="form-control"
              step="0.1"
              min="0"
              {...netWeightOz.input}
              onChange={this.updateOz}
              onBlur={this.updateOz}
            />,
            <span className="input-group-addon">oz</span>
          ]}
          <div className={inputGroupClasses}>
            <button
              type="button"
              className="btn btn-default dropdown-toggle"
              onClick={this.toggle}
            >
              <i className="fa fa-caret-down" />
            </button>
            <ul className="dropdown-menu dropdown-menu-right">
              <li>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={this.setPounds}
                >
                  Standard (Lbs.)
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={this.setKilos}
                >
                  Metric (Kgs.)
                </button>
              </li>
            </ul>
          </div>
        </div>
        {errors}
      </div>
    );
  }
}

export default withFormFields(NetWeight, [
  NET_WEIGHT,
  NET_WEIGHT_UNIT,
  NET_WEIGHT_OZ
]);



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/NetWeight.jsx